export enum ViewerDataEventObject {
  AI_SUGGEST = 'ai_suggest',
  AI_SUGGEST_SOURCES = 'ai_suggest_sources',
  AI_SENT_SOURCES = 'ai_sent_sources',
  SUGGESTED_REPLY_FEEDBACK = 'suggested_reply_feedback',
  SYNOPSIS = 'synopsis',
  SYNOPSIS_GLOBAL_FEEBACK = 'synopsis_global_feedback',
  SYNOPSIS_INSIGHT_INCORRECT = 'synopsis_insight_incorrect',
  SYNOPSIS_ITEM = 'synopsis_item',
  SYNOPSIS_FILTER = 'synopsis_filter',
  SYNOPSIS_ITEM_RELATED = 'synopsis_item_related',
  ANNOTATION = 'annotation',
  TOPIC = 'topic',
  MACRO = 'macro',
  CONVERSATION_SUMMARY = 'conversation_summary',
  CONVERSATION_SUMMARY_GENERATE = 'conversation_summary_generate',
  CONVERSATION_SUMMARY_SETTINGS = 'conversation_summary_settings',
  CONVERSATION_SUMMARY_ERROR = 'conversation_summary_error',
  MESSAGE_TRANSLATION = 'translation',
  MESSAGE_TRANSLATION_SETTINGS = 'translation_settings',
  CONVERSATION_TITLE = 'conversation_title',
  INBOX = 'inbox',
  TICKET_ID = 'ticket_id',
  PARTICIPANTS_MENU = 'participants_menu',
  PARTICIPANTS_MENU_ADD = 'participants_menu_add',
  PARTICIPANTS_MENU_ADD_CONFIRM = 'participants_menu_add_confirm',
  SNOOZE = 'snooze',
  SNOOZE_CUSTOM_CONFIRM = 'snooze_custom_confirm',
  SNOOZE_CUSTOM_CANCEL = 'snooze_custom_cancel',
  TAGS_MENU = 'tags_menu',
  TAGS_MENU_ADD = 'tags_menu_add',
  TAGS_MENU_ADD_CREATE = 'tags_menu_add_create',
  TAG = 'tag',
  CONVERSATION = 'conversation',
  CUSTOM_FIELDS = 'custom_fields',
  CUSTOM_FIELDS_ADD = 'custom_fields_add',
  LINKED_CONVERSATIONS = 'linked_conversations',
  LINKED_CONVERSATIONS_ADD = 'linked_conversations_add',
  OBJECTS = 'objects',
  OBJECTS_ADD = 'objects_add',
  ADD_PROPERTIES = 'add_properties',
  CONVERSATION_MORE = 'conversation_more',
  ASSIGN = 'assign',
  ARCHIVE = 'archive',
  CHANGE_STATUS = 'change_status',

  // Suggested reply redesign
  AI_SUGGEST_INQUIRY_SR_HOVER = 'inquiry_sr_hover',
  AI_SUGGEST_INQUIRY_SR = 'inquiry_sr',

  // Autopilot
  AI_BANNER_STANDBY = 'ai_banner_standby',
  AI_BANNER_ACTIVE = 'ai_banner_active',
  AI_INTERRUPTION_MODAL = 'ai_interruption_modal',
  AI_HANDOFF_COMMENT = 'ai_handoff_comment',
  AUTOPILOT_REPLY_FEEDBACK = 'autopilot_reply_feedback',

  // AI Fact Invalidation
  AI_FACT_INVALIDATION = 'ai_fact_invalidation',

  // AI Compose Assistant
  AI_COMPOSE_ASSISTANT = 'ai_compose_assistant',
  AI_COMPOSE_ASSISTANT_REFERENCE_ADD = 'ai_compose_assistant_reference_add',
  AI_COMPOSE_ASSISTANT_ACCEPT = 'ai_compose_assistant_accept',
  AI_COMPOSE_ASSISTANT_DISCARD = 'ai_compose_assistant_discard',
  AI_COMPOSE_ASSISTANT_RETRY = 'ai_compose_assistant_retry',
  AI_COMPOSE_ASSISTANT_CANCEL = 'ai_compose_assistant_cancel',
  AI_COMPOSE_ASSISTANT_INPUT = 'ai_compose_assistant_input',
  AI_COMPOSE_ASSISTANT_CLOSE = 'ai_compose_assistant_close',
  AI_COMPOSE_ASSISTANT_ERROR = 'ai_compose_assistant_error',

  // Header
  INBOX_IMPROVEMENTS_HEADER_EXPAND_TIP = 'inbox_improvements_header_expand_tip',
}
